<template>
  <div>
    <app-cells><h1 class="title">Funding</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view :key="$route.name" />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'TransferPricingFundingLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { id: 'payments', name: 'transfer-pricing-funding-payments', label: 'Payments' },
        { id: 'altezza', name: 'transfer-pricing-funding-altezza-queue', label: 'Altezza Queue' },
        { id: 'altura', name: 'transfer-pricing-funding-altura-queue', label: 'Altura Queue' },
      ],
    }
  },
}
</script>
